import { AnimatePresence, motion } from 'framer-motion'

export interface ToastAction {
  label: string
  onClick: () => void
}

// A one-off message with its own actions, in the toast's look (UndoToast's
// inverted bar): "Anna finished the trip · Keep shopping / Done". It stays until one is tapped — the last action closes it.
export function ActionToast({ id, text, actions }: {
  /** Changes when the message does, so the next one animates in. */
  id: string | null
  text: string
  actions: ToastAction[]
}) {
  return (
    <div className="ml-toast-slot" role="status" aria-live="polite">
      <AnimatePresence>
        {id && (
          <motion.div key={id} className="ml-toast ml-toast--actions"
            initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
            transition={{ duration: 0.2, ease: [0.2, 0.8, 0.2, 1] }}>
            <span className="ml-toast__text">{text}</span>
            {actions.map(a => (
              <button key={a.label} type="button" className="ml-text-btn" onClick={a.onClick}>{a.label}</button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
